import { Box } from "@mui/material";
import { useMemo, useState } from "react";
import {
  AutocompleteArrayInput,
  Button,
  Datagrid,
  List,
  ReferenceArrayInput,
  ReferenceField,
  TextField,
  TextInput,
} from "react-admin";
import { GenericColorChip } from "shared/components/chips/GenericColorChip";
import CustomDateField from "shared/components/fields/CustomDateField";
import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { planningMaskModeChoices } from "shared/enums/reactAdminChoices";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { maskModeColorMapping } from "shared/enums/colorMappings/globalColorMappings";
import PlanningMaskChart from "../../../features/charts/planning/PlanningMaskChart";

export const PlanningMaskList = () => {
  const [isListMode, setIsListMode] = useState(true);

  const toggleViewMode = () => {
    setIsListMode((prevState) => !prevState);
  };

  const planningMasksFilters = useMemo(
    () => [
      <CustomDateTimeInput key="start_date__lt" label="Start date before" source="start_date__lt" />,
      <CustomDateTimeInput key="start_date__gt" label="Start date after" source="start_date__gt" />,
      <CustomDateTimeInput key="end_date__lt" label="End date before" source="end_date__lt" />,
      <CustomDateTimeInput key="end_date__gt" label="End date after" source="end_date__gt" />,
      <TextInput key="operating_mode" source="operating_mode" />,
      <AutocompleteArrayInput key="operating_mode__in" source="operating_mode__in" choices={planningMaskModeChoices} />,
      <ReferenceArrayInput key="site_id__in" source="site_id__in" reference={SiteResourcesEnum.Sites} label="Sites">
        <AutocompleteArrayInput label="Sites" blurOnSelect={false} disableCloseOnSelect sx={{ minWidth: 300 }} />
      </ReferenceArrayInput>,
      <TextInput key="operator_name" source="operator_name" />,
    ],
    [],
  );

  const listProps = isListMode
    ? {
        filters: planningMasksFilters,
        perPage: 10,
      }
    : {
        pagination: <></>,
      };

  return (
    <Box>
      <Button
        label={isListMode ? "View Graph" : "View List"}
        variant="contained"
        size="large"
        onClick={toggleViewMode}
        sx={{ mt: 2 }}
      />
      <List
        {...listProps}
        exporter={false}
        filterDefaultValues={{
          end_date__gt: new Date().toISOString(),
        }}
      >
        {isListMode ? (
          <Datagrid bulkActionButtons={false}>
            <TextField source="site_id" />
            <ReferenceField source="site_id" reference={SiteResourcesEnum.Sites} link={"show"}>
              <TextField source="name" />
            </ReferenceField>
            <GenericColorChip source="operating_mode" colorMapping={maskModeColorMapping} />
            <CustomDateField showTime source="start_date" />
            <CustomDateField showTime source="end_date" />
            <TextField source="operator_name" label="Operator Name" />
          </Datagrid>
        ) : (
          <PlanningMaskChart />
        )}
      </List>
    </Box>
  );
};
